
import {useState, useContext, useEffect, useRef} from 'react';
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import ServiciosHogarPlanesContext from "context/ServiciosHogarPlanesContext";
import ErrorMessage from 'components/ErrorMessage';

const HOGARPLAN_VALUES = {
    image: '',
    subcategory: '', 
    plan: '',
    // benefits: [],
    unitPrice: "",
    comboPrice: "",
    isActive: false
}

const BENEFITS_VALUES = {
 "benefits[0]": '',
 "benefits[1]": '',
 "benefits[2]": '',
 "benefits[3]": '',
 "benefits[4]": '',
}

function Form({createHogarPlan, updateHogarPlan, setIsSearched, category, formEstado, setFormEstado}){
 const {hogarPlan: selectedHP, setHogarPlan: setSelectedHP, message, setMessage} = useContext(ServiciosHogarPlanesContext);
 
 const [form, setForm] = useState(HOGARPLAN_VALUES);
 const {image, subcategory, plan, /* benefits, */ unitPrice, comboPrice, isActive} = form;
 
 const [countBenefits, setCountBenefits] = useState([...Array(5).keys()]);
 const [formBenefits, setFormBenefits] = useState(BENEFITS_VALUES);
 
 let imgPreview = useRef();
 let inputFile = useRef();

 let myAbi = HelpAbility();
 const handleChange = (e) => {
     setForm({...form, [e.target.name]: e.target.value.trimStart()});
 }

 const handleChangeBool = (e) => {
     setForm({...form, [e.target.name]: e.target.value === 'true'});
 }

 const handleBenefits = (e) => {
  setFormBenefits({
   ...formBenefits,
   [e.target.name]: e.target.value.trimStart()
  })
 }

 const handleChangeFile = (e) => {
   //!Visualización de la Imagen
   const selectedFile = e.target.files[0];
   const reader = new FileReader();
   reader.readAsDataURL(selectedFile);
   reader.onloadend = () => {
    imgPreview.current.src = reader.result;
   }

   //!Asignar al objeto controlador
   setForm({...form, [e.target.name]:  e.target.files[0]})
   console.log(e.target.files[0])
 }

 const handleSubmit = async (e) => {
    e.preventDefault();
    if(category === 'adicionales'){
        //!Comprobando que la imagen sea de tipo arraybufer o sea un objeto
        if(!image){
            setMessage({status: 404, message: "Ingrese una imagen por favor"})
            return null;
        }
        if(!subcategory){
            setMessage({status: 404, message: "Ingrese una subcategoría por favor"})
            return null;
        }
    }
    if(!plan ){
     setMessage({status: 404, message: `Ingrese un plan de servicio hogar ${category}`})
     return null;
    }
    if(!unitPrice || unitPrice < 1){
     setMessage({status: 404, message: "Ingrese un precio unitario válido"})
     return null;
    }
    if(category === 'internet' || category === 'television' || category === 'telefonía'){
        if(!comboPrice || comboPrice < 1){
         setMessage({status: 404, message: "Ingrese un precio combo válido"})
         return null;
        }        
        let someBenefit = Object.values(formBenefits).some((benefit) => benefit !== '' )
        if(!someBenefit){
         setMessage({status: 404, message: "Ingrese al menos un beneficio"})
         return null;
        }
    }
    

    let formData = new FormData();
    formData.append("category", category);
    formData.append("image", image);
    formData.append("subcategory", subcategory);
    formData.append("plan", plan);

    for(let prop in formBenefits){
     formData.append(prop, formBenefits[prop]);
    }

    formData.append("unitPrice", unitPrice);
    formData.append("comboPrice", comboPrice);
    formData.append("isActive", isActive);

    let status = Object.keys(selectedHP).length ? await updateHogarPlan({hogarPlan: formData, id: selectedHP._id, category }) : await createHogarPlan({hogarPlan: formData, category});

    if(!status) {
        setIsSearched({
            search: '',
            option: '',
            state: false
        })
        setForm(HOGARPLAN_VALUES) 
        setFormBenefits(BENEFITS_VALUES)
        inputFile.current.value = ""
        setSelectedHP({});
        setMessage({message: '', status: 200})
    }
 }
 


 const handleReset = () => {
    setForm(HOGARPLAN_VALUES);
    setFormBenefits(BENEFITS_VALUES);
    inputFile.current.value = ""
    setSelectedHP({});
    setMessage({message: '', status: 200})
 }

 const isVisibleForm = Object.keys(selectedHP).length ? myAbi.has(C.A.SERVICIOSHOGARPLANES.UPDATE) : myAbi.has(C.A.SERVICIOSHOGARPLANES.CREATE);

 useEffect(() => {
  if(category === 'internet') {
   setCountBenefits([...Array(5).keys()])
   setFormBenefits(BENEFITS_VALUES)
   setFormEstado({
    image: false,
    subcategory: false, 
    plan: true,
    benefits: true,
    unitPrice: true,
    comboPrice: true,
    isActive: true
   })
  }else if(category === 'television' || category === 'telefonia'){
   setCountBenefits([...Array(4).keys()])
   setFormBenefits({
    "benefits[0]": '',
    "benefits[1]": '',
    "benefits[2]": '',
    "benefits[3]": ''
   })
   setFormEstado({
    image: false,
    subcategory: false, 
    plan: true,
    benefits: true,
    unitPrice: true,
    comboPrice: true,
    isActive: true
   })
  }else{
   setCountBenefits([])
   setFormBenefits({})
   setFormEstado({
    image: true,
    subcategory: true, 
    plan: true,
    benefits: false,
    unitPrice: true,
    comboPrice: false,
    isActive: true
   })
  }
  setMessage({
   message: '',
   status: 200
  })
  setForm(HOGARPLAN_VALUES);
  setFormBenefits(BENEFITS_VALUES);
  setSelectedHP({});

  // eslint-disable-next-line
 }, [category]);


 useEffect(() => {
    if (!Object.keys(selectedHP).length) return null;

    let newBenefits = {}
    selectedHP.benefits.forEach((benefit, i) => {
        newBenefits[`benefits[${i}]`] = benefit 
    })
    setForm(selectedHP)
    setFormBenefits({
        ...formBenefits,
        ...newBenefits
    })
    // eslint-disable-next-line
 }, [selectedHP])

 return (
  <>
  {isVisibleForm 
  &&
  
   <div className="mt-4">
    <div className="row mb-2">
        <h6>{Object.keys(selectedHP).length ? 'Editar' : 'Agregar'} Plan</h6>
    </div>
    {message.status !== 200 && message.message && <ErrorMessage message={message.message}></ErrorMessage>}
    <div className="table-responsive rounded-3" style={{border: '1px solid black', paddingTop: '15px'}}>
    <div className="container">
     <div className="row mb-3 d-flex justify-content-center">
      <div className="col-3 themed-grid-col">
       {formEstado.image && 
        <div className="mb-3">
            <label htmlFor="image" className="form-label">Imagen</label>
            <input type="file" className="form-control" id="image" name="image" autoComplete="off" accept="image/*" onChange={handleChangeFile} ref={inputFile}/>
        </div>
       }
       
       {formEstado.subcategory &&
        <div className="mb-3">
            <label htmlFor="subcategory" className="form-label">Subcategoría</label>
            <input type="text" className="form-control" id="subcategory"
                    name="subcategory" autoComplete="off" value={subcategory} onChange={handleChange} placeholder="Ej. Canal, Revista, Servicio, etc"/>
        </div>       
       }      
       <div className="mb-3">
           <label htmlFor="plan" className="form-label">Plan</label>
           <input type="text" className="form-control" id="plan"
                   name="plan" autoComplete="off" value={plan} onChange={handleChange} placeholder="Ej. 80 Megas, Digital Plus, HBO, etc"/>
       </div>
      </div>
      
      <div className="col-3 themed-grid-col" style={{paddingLeft: '10px'}}>
       {formEstado.benefits 
           ?
           <div className="mb-3">
               <label htmlFor="benefits" className="form-label">Beneficios</label>
               {countBenefits.map((benefit) => (
                <input type="text" className="form-control mb-1" id={`benefits[${benefit}]`} name={`benefits[${benefit}]`} autoComplete="off" value={formBenefits[`benefits[${benefit}]`]} placeholder={`${benefit+1}. Beneficio`} onChange={handleBenefits}/>
               ))}
           </div>
           :
           <div>
            <p className="h6">Visualización de la Imagen</p>
            <div className="card mb-3">
                <img className="card-img-top" src={image || `/img/placeholder-image.png`} alt={plan} ref={imgPreview} ></img>
            </div>
           </div>
       }
      </div>

      <div className="col-3 themed-grid-col" style={{paddingLeft: '10px'}}>
       <div className="mb-3">
           <label htmlFor="unitPrice" className="form-label">Precio Unitario</label>
           <div className="input-group ">
            <div className="input-group-prepend">
                <span className="input-group-text">$</span>
            </div>
            <input type="number" className="form-control" id="unitPrice" name="unitPrice" autoComplete="off" value={unitPrice} onChange={handleChange} placeholder="Ej. 73900, 70900, 33900"/>
           </div>
       </div>
       {formEstado.comboPrice && 
        <div className="mb-3">
            <label htmlFor="comboPrice" className="form-label">Precio Combo</label>
            <div className="input-group ">
                <div className="input-group-prepend">
                    <span className="input-group-text">$</span>
                </div>
                <input type="number" className="form-control" id="comboPrice"
                    name="comboPrice" autoComplete="off" value={comboPrice} onChange={handleChange} placeholder="Ej. 61900, 46303, 13000"/>
            </div>
        </div>
       }
       <div className="mb-3">
        <label htmlFor="isActive" className="form-label d-block">Disponible</label>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" name="isActive"
                  onChange={handleChangeBool}
                  checked={isActive === true} id="isVisible-radio-true"
                  value={true} />
          <label className="form-check-label" htmlFor="isVisible-radio-true">Si</label>
        </div>
        <div className="form-check form-check-inline">
         <input className="form-check-input" type="radio" name="isActive"
                 onChange={handleChangeBool}
                 checked={isActive === false} id="isVisible-radio-false"
                 value={false} />
         <label className="form-check-label" htmlFor="isVisible-radio-false">No</label>
        </div>
       </div>
      </div>

      <div className="col-3 themed-grid-col d-flex justify-content-center align-items-center" style={{paddingLeft: '10px'}}>
       <div className="mb-3 w-100">
        <button className={'d-block w-100 mb-2 btn btn-' + (true ? 'success' : 'primary')} type="submit" onClick={handleSubmit}><i className="bi bi-save"/>{Object.keys(selectedHP).length ? 'Actualizar' : 'Guardar'}</button>
        <button type="reset" className="d-block w-100 btn btn-secondary" onClick={handleReset}><i
            className="bi bi-eraser"/> Limpiar
        </button>
       </div>
      </div>
     </div>
    </div>
    </div>
   </div>
  }
  </>
 )
}
export default Form
